/* 特斯拉记录数据 */
export default [
  {
    path: '/tesla/customRecord/index',
    name: '特斯拉记录数据',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/tesla/customRecord/index.vue`),
    meta: {
      permission: ['tesla_custom_record_index']
    }
  },
  {
    path: '/tesla/financialStatements/index',
    name: '工资记账报表',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/tesla/financialStatements/index.vue`),
    meta: {
      permission: ['tesla_pay_accounting_report']
    }
  }
]
